import axios from "axios";
import { API_SERVICE_BACKEND } from "src/config";

// ✅ 1. Fast local read (same as before)
export const getFeatureFlags = () => {
  try {
    const raw = sessionStorage.getItem("featureFlagObject");
    if (!raw || raw === "undefined" || raw === "null") return {};
    const features = JSON.parse(raw);

    // Check if the current user email is allowed for AI calls
    const userEmail = sessionStorage.getItem("userEmail") || "";
    const allowedEmails = [
      // "emily@promotionpros.com",
      // "ric.hall@securafy.com",
      // "toby@challengetesting.com",
      // "josh@fipprinting.com",
      // "supton@barrister.com",
      // "pvsir99@gmail.com"
    ];
    if (features && typeof features === "object") {
      if (!userEmail || !allowedEmails.includes(userEmail.trim().toLowerCase())) {
        features.AI_VOICE_AGENT = false;
      }
    }

    return features;
  } catch (e) {
    console.error("Invalid featureFlagObject in sessionStorage", e);
    return {};
  }
};

// ✅ 2. Simple flag check (unchanged)
export const isFeatureEnabled = (key) => {
  const featureFlags = getFeatureFlags();
  const value = featureFlags?.[key];
  return value === true || (typeof value === "number" && value > 0);
};

// ✅ 3. Background updater (optional)
export const refreshFeatureFlagsFromAPI = async () => {
  const email = sessionStorage.getItem("userEmail");
  if (!email) return;

  try {
    const res = await axios.get(`${API_SERVICE_BACKEND}/getuserdetail?email=${encodeURIComponent(email)}`);
    const features = res?.data?.data?.userSubscription?.subscriptions?.base?.features || {};
    sessionStorage.setItem("featureFlagObject", JSON.stringify(features));
  } catch (error) {
    console.error("Error refreshing feature flags:", error);
  }
};
